import React, { useEffect, useState } from "react";
import "./payment-overview-content.component.sass";
import Grid from "@material-ui/core/Grid/Grid";
import { history } from "react-router-guard";
import { BillingCardComponent } from "../billing-card/billing-card.component";
import { PaymentService } from "../../services/payment/payment.service";
import { useTranslation } from "react-i18next";
import PaymentRow from "./components/payment-row/payment-row.component";
import CreditCardDetails from "./components/crediat-card-details/credit-card-details.component";
import { Card } from "src/types/card";
import { PaymentDetails } from "src/types/payment-details";
import { formatDate } from "src/helpers";


export default function PaymentOverviewContent() {
  const paymentService = new PaymentService();
  const emptyObj: any = {};
  const [card, setCard] = useState(new Card());
  const [upcomingInvoice, setUpcomingInvoice]: any = useState(emptyObj);
  const [latestHistory, setLatestHistory]: any = useState('');
  const [upcomingInvoiceloading, setUpcomingInvoiceLoading]: any = useState(true);
  const [paymentLoading, setPaymentLoading]: any = useState(true);
  const [billingDetails, setBillingDetails]: any = useState(new PaymentDetails());
  const [t] = useTranslation();

  const navigate = (path: string) => {
    history.push(path);
  };

  async function fetchData() {
    const nextInvoice = await paymentService.listNextInvoice();
    setUpcomingInvoice(nextInvoice);
    setUpcomingInvoiceLoading(false);
    const paymentDetails = await paymentService.listPaymentDetails();
    const paymentHistory = await paymentService.listPaymentHistory();
    setBillingDetails(paymentDetails);
    setLatestHistory(paymentHistory);
    const card = paymentDetails.card;
    setCard((card && card.type) ? card : new Card());
    setPaymentLoading(false);
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="overview-content">
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6} className="left-container">
          <BillingCardComponent
            header="invoice-amounts"
            hint="prices-includes-vat"
            title="invoice-preview"
            subtitle="invoice-preview-sub"
            loading={upcomingInvoiceloading}
          >
            {!upcomingInvoice.date && (
              <div className="no-data">{t("no upcoming payments")}</div>
            )}
            {upcomingInvoice.date && (
              <div className="content">
                <div className="first-text">{t("next-billing-on")} {formatDate(upcomingInvoice.start, "DD.MM.YYYY")}</div>
                <PaymentRow from={upcomingInvoice.start} to={upcomingInvoice.end} amount={upcomingInvoice.amount} />
              </div>
            )}
          </BillingCardComponent>
        </Grid>
        <Grid item xs={12} lg={6} className="right-container">
          <BillingCardComponent
            header="address-and-method"
            button="open-invoice-details"
            buttonAction={navigate.bind(null, '/payment/details')}
            title="billing-details"
            subtitle="billind-details-subtitle"
            loading={paymentLoading}
          >
            {!billingDetails.card && (
              <div className="no-data">{t("no saved details")}</div>
            )}
            {billingDetails.card && (
              <div className="content">
                <CreditCardDetails
                  billingDetails={billingDetails}
                  card={card}
                />
              </div>
            )}
          </BillingCardComponent>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6} className="left-container">
          <BillingCardComponent
            header="invoice-amounts"
            hint="prices-includes-vat"
            button="open-invoice-details"
            buttonAction={navigate.bind(null, '/payment/history')}
            title="billing-history"
            subtitle="billing-history-sub"
            loading={paymentLoading}
          >
            {!latestHistory.length && (
              <div className="no-data">{t("no latest histiory")}</div>
            )}
            {latestHistory && (
              <div className="content">
                {latestHistory.slice(0, 3).map((item: any, index: number) => (
                  <PaymentRow
                    key={index}
                    from={item.start}
                    to={item.end}
                    amount={item.amount}
                  />
                ))}
              </div>
            )}
          </BillingCardComponent>
        </Grid>
      </Grid>
    </div>
  );
}
